/**
 * Method to translate given keys
 * @param {string|object} key Key, der übersetzt werden soll oder Hashmap mit Übersetzungen (key value pairs)
 * @param {string} [fallback]
 * @param {object} [values]
 */
function translate(key, fallback, values) {
    if (typeof key === "string") {
        // return translation
        return translate.get(key, fallback, values);
    } else if (typeof key === "object") {
        // set translations
        translate.set(key);
    }
}
translate.translations = {};
/**
 * Check if translation exists
 * @param {string} key
 * @returns {boolean}
 */
translate.has = function(key) {
        return translate.translations[key] !== void 0;
    }
    /**
     * Set translation
     * chainable
     * @param {string|object} key | key-translation-pairs
     * @param {string} translation
     * @returns {function} translate
     */
translate.set = function(key, translation) {
        if (typeof key === "object") {
            var translations = key;
            Object.keys(translations).forEach(function(key) {
                translate.set(key, translations[key]);
            });
        } else {
            translate.translations[key] = translation;
        }
        return translate;
    }
    /**
     * Get translation
     * translate.get("key") === translate("key")
     * @param {string} key
     * @param {string} [fallback]
     * @returns {string}
     */
translate.get = function(key, fallback, values) {
    if (fallback !== null && typeof fallback === "object") {
        values = fallback;
        fallback = void 0;
    }
    var translated = (translate.translations[key] ||  fallback ||  (fallback === void 0) && key) || "";
    if (values !== null && typeof values === "object") {
        Object.keys(values).forEach(function(key) {
            translated = translated.replace(new RegExp("%" + key + "%", "g"), values[key] || "");
        });
    }
    return translated;
}

translate.push = function(...items) {
    items.forEach(item => translate.set(item))
    return translate
}

translate.language = function() {
    return document.documentElement.lang;
}

/**
 * removes given key
 * chainable
 * @param {string} key
 * @returns {function} translate
 */
translate.unset = function(key) {
    translate.translations[key] = void 0;
    return translate;
}

if (Array.isArray(window.translate)) {
    window.translate.forEach(function(translations) {
        translate.set(translations);
    })
}

window.translate = translate

export default translate;
